module.exports = __webpack_public_path__ + "static/img/5.94fdd94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/snip3down/5.png
// module id = y78G
// module chunks = 35